module.exports = __webpack_public_path__ + "media/images/frontend/covid19_sintomas-9da91d7297b066a15b00b050fc8954a5.svg";